<div fxLayout="row" fxLayoutGap="15px">
  <mat-card fxFlex="none" class="thumbnails-card">
    <mat-card-content>
      <div *ngIf="selectedPages$ | async as selectedPages" fxLayout="column">
        <a
          *ngFor="let page of pages$ | async"
          (click)="onPageSelect({ page, event: $event })"
          class="thumbnail"
          [ngClass]="{ 'selected': selectedPages.has(page.pageNum) }"
        >
          <img [src]="page.thumbnail" />
          <div class="text-center page-num">
            {{ page.pageNum }} / {{ totalPages }}
          </div>
        </a>
      </div>
    </mat-card-content>
  </mat-card>

  <mat-card fxFlex class="document-card">
    <mat-progress-bar [mode]="blocksLoading || (loading$ | async) ? 'indeterminate' : 'determinate'"></mat-progress-bar>
    <mat-card-header>
      <ng-content [select]="[card-header]"></ng-content>
    </mat-card-header>

    <mat-card-content>
      <div style="position: relative;">
        <mmx-pdf-text-layer
          *ngIf="blocks?.length"
          [blocks]="blocks"
          [page]="currentPage"
        >
        </mmx-pdf-text-layer>
        <canvas #pdfCanvas></canvas>
      </div>
    </mat-card-content>
  </mat-card>
</div>
